import React from "react";

export default function About() {
  return (
    <section id="about" className="relative bg-black px-5 py-16 sm:py-20">
      <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">The Formula</div>
          <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
            What is <br />
            <span className="text-fire">Bajrang Veda?</span>
          </h2>
        </div>
        <div className="space-y-4 text-neutral-300 lg:col-span-3">
          <p className="leading-relaxed">
            Bajrang Veda is an Ayurvedic nutritional supplement formulated using
            traditional herbs that may support healthy weight gain, improved
            appetite, strength, stamina, better digestion, and lean muscle
            development — when combined with proper nutrition and exercise.
          </p>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {[
              "Healthy weight gain",
              "Improved appetite",
              "Strength",
              "Stamina",
              "Better digestion",
              "Lean muscle support",
            ].map((x) => (
              <li key={x} className="flex items-center gap-2 rounded-xl border border-white/5 bg-white/5 px-3 py-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#FF7A00]" />
                {x}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
